import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';

const TypingLoader = () => {
  const loaderAnimation = keyframes`
  to {
    clip-path: inset(0 -34% 0 0);
  }
`;
  return (
    <Box
      data-testid="typing-loader"
      sx={(theme) => {
        const dotColor = theme.palette.text.primary;
        return {
          width: '30px',
          aspectRatio: '4',
          background: `radial-gradient(circle closest-side, ${dotColor} 90%, transparent) 0 / calc(100% / 3) 100% space`,
          clipPath: 'inset(0 100% 0 0)',
          animation: `${loaderAnimation} 1s steps(4) infinite`,
          marginTop: '10px',
        };
      }}
    />
  );
};

export default TypingLoader;
